import virginParticular1 from './virginParticular1';

export default {
    virginParticular1,
};